export const fetchDeposits = async (client, address, params, network, progress) => {
    const chainHead = await client.request("ChainHead");
    const height = chainHead.Height;
    const latestTXs = await client.request("StateListMessages", {
        Version: 0,
        To: address,
        From: null,
        Nonce: 0,
        Value: "0",
        GasPrice: "0",
        GasLimit: 0,
        Method: 0,
        Params: params,
    }, [], progress === 0 ? height - 100 : progress);
    return {
        txs: await Promise.all((latestTXs || []).map(async (cid) => fetchMessage(client, cid["/"], network, height))),
        progress: height + 1,
    };
};
export const fetchMessage = async (client, cid, network, height) => {
    const [details, receipt, { Height: chainHeight }] = await Promise.all([
        client.request("ChainGetMessage", { "/": cid }),
        client.request("StateSearchMsg", { "/": cid }).catch(() => undefined),
        height ? { Height: height } : client.request("ChainHead"),
    ]);
    if (network === "testnet") {
        details.To = details.To.replace(/^f/, "t");
        details.From = details.From.replace(/^f/, "t");
    }
    const tx = {
        cid,
        amount: details.Value,
        params: details.Params || "",
        nonce: details.Nonce,
        confirmations: receipt ? chainHeight - receipt.Height : 0,
    };
    return tx;
};
//# sourceMappingURL=lotus.js.map